<template>
  <div
    class='featured-jobs__list'
  >
    <Job
      class='featured-jobs__job'
      v-for='result in results'
      :key="result.id"
      :job='result'
      :show="{
        date: false,
        company: true,
        motto: false,
      }"
    />
  </div>
</template>

<script>
import Job from "../company/job.vue";

export default {
  components: {
    Job,
  },

  data() {
    return {
      results: window.__DATA__.jobs,
    };
  },
};
</script>

<style lang="scss" scoped>
.featured-jobs__list {
}
.featured-jobs__job {
}
</style>



// WEBPACK FOOTER //
// app/javascript/components/featured-jobs.vue?48822ba2